import axios from 'axios';
import END_POINT from '../config/endpoints.constants';
import { CustomerNumber, BusinessNumber, VriAPIResult, VriAPIResponse, UUID } from '../types';

interface GetOwnedCustomerNumberResult {
    numbers?: CustomerNumber[];
    error?: any;
}
interface GetOwnedCustomerNumberResponse {
    code: number;
    data: {
        numbers: CustomerNumber[];
    };
    message: string;
}

export interface GetNumbersOwnedByTypeBusinessResult extends VriAPIResult {
    data?: {
        businessNumbers: BusinessNumber[];
    };
}

export interface GetNumbersOwnedByTypeBusinessResponse extends VriAPIResponse {
    data: BusinessNumber[];
}
export async function getOwnedCustomerNumber(
    userId: string,
): Promise<GetOwnedCustomerNumberResult> {
    const result = {} as GetOwnedCustomerNumberResult;
    try {
        const { data: responseData } = await axios.post<GetOwnedCustomerNumberResponse>(
            END_POINT.CUSTOMER_NUMBER_OWNED,
            {
                userId,
            },
        );
        if (responseData) {
            const { data } = responseData;
            result.numbers = data.numbers;
        }
    } catch (error) {
        result.error = error;
    }
    return result;
}

interface GetUsedCustomerNumberResult {
    numbers?: CustomerNumber[];
    error?: any;
}

interface GetUsedCustomerNumberResponse {
    code: number;
    data: {
        numbers: CustomerNumber[];
    };
    message: string;
}
export async function getUsedCustomerNumber(userId: string): Promise<GetUsedCustomerNumberResult> {
    const result = {} as GetUsedCustomerNumberResult;
    try {
        const { data: responseData } = await axios.post<GetUsedCustomerNumberResponse>(
            END_POINT.CUSTOMER_NUMBER,
            {
                userId,
            },
        );
        if (responseData) {
            const { data } = responseData;
            result.numbers = data.numbers;
        }
    } catch (error) {
        result.error = error;
    }
    return result;
}

interface GetBusinessNumberOwnedByCustomerResult {
    numbers?: BusinessNumber[];
    error?: any;
}

interface GetBusinessNumberOwnedByCustomerResponse {
    code: number;
    data: BusinessNumber[];
    message: string;
}
export async function getBusinessNumberOwnedByCustomer(
    userId: string,
): Promise<GetBusinessNumberOwnedByCustomerResult> {
    const result = {} as GetBusinessNumberOwnedByCustomerResult;
    try {
        const { data: responseData } = await axios.post<GetBusinessNumberOwnedByCustomerResponse>(
            END_POINT.CUSTOMER_BUSINESS_NUMBER_OWNED,
            {
                userId,
            },
        );
        if (responseData) {
            const { data } = responseData;
            result.numbers = data;
        }
    } catch (error) {
        result.error = error;
    }
    return result;
}

export interface GetNumbersOwnedByTypePersonResult extends VriAPIResult {
    data?: {
        numbers: CustomerNumber[];
    };
}

export interface GetNumbersOwnedByTypePersonResponse extends VriAPIResponse {
    data: {
        numbers: CustomerNumber[];
    };
}

export async function getNumbersOwnedByTypePerson(
    userId: UUID,
): Promise<GetNumbersOwnedByTypePersonResult> {
    const result: GetNumbersOwnedByTypePersonResult = {};
    try {
        const { data: responseData } = await axios.post<GetNumbersOwnedByTypePersonResponse>(
            END_POINT.GET_NUMBERS_OWNED_BY_TYPE_PERSON,
            { userId },
        );
        if (responseData) {
            result.data = { numbers: responseData.data.numbers };
        }
    } catch (error) {
        result.error = error;
    }
    return result;
}

export async function getNumbersOwnedByTypeBusiness(
    userId: UUID,
): Promise<GetNumbersOwnedByTypeBusinessResult> {
    const result: GetNumbersOwnedByTypeBusinessResult = {};
    try {
        const { data: responseData } = await axios.post<GetNumbersOwnedByTypeBusinessResponse>(
            END_POINT.GET_NUMBERS_OWNED_BY_TYPE_BUSINESS,
            { userId },
        );
        if (responseData) {
            result.data = { businessNumbers: responseData.data };
        }
    } catch (error) {
        result.error = error;
    }
    return result;
}
